import { IoAddCircle } from "react-icons/io5";
import { RxCross2 } from "react-icons/rx";
import { toast } from "react-toastify";
import { Button, Card, Label } from "reactstrap";

const VideoUploadInput = ({ value, setValue, id, hideShadow, noPadding }) => {
  return (
    <Label
      style={{ borderRadius: "13.48px" }}
      className={` m-0  d-flex full-width ${noPadding ? "p-0" : "p-3 "} ${
        hideShadow ? "" : "outer-transparent-shadow "
      }`}
      htmlFor={id}
    >
      <Card
        style={{
          background: "rgba(241, 241, 241, 1)",
          minHeight: "150px",
          borderRadius: "18.19px",
        }}
        className="border-dashed-primary-blue p-0  full-width position-relative d-flex align-items-center justify-content-center full-width"
      >
        {value !== null && (
          <Button
            onClick={(e) => {
              e?.preventDefault();
              setValue(null);
            }}
            className="bg-danger p-0 full-rounded  position-absolute border-none d-flex align-items-center justify-content-center"
            style={{
              height: 30,
              width: 30,
              top: "-15px",
              right: "-14px",
              zIndex: 3,
            }}
          >
            <RxCross2 size={15} color="white" strokeWidth={"1px"} />
          </Button>
        )}
        {value !== null ? (
          <video
            height={150}
            src={
              value instanceof File
                ? URL.createObjectURL(value)
                : typeof value === "string"
                ? value
                : Array.isArray(value) && typeof value[0] === "string"
                ? value[0]
                : ""
            }
            style={{ borderRadius: "18.19px" }}
            className="full-width object-fit-cover"
            controls
            muted
          />
        ) : (
          <div className="color-primary-blue">
            <IoAddCircle size={30} />
          </div>
        )}
        <input
          onChange={(e) => {
            if(e?.target?.files?.[0]?.size>40&&e?.target?.files?.[0]?.type=="video")
            toast.warn("Please upload a shorter video < 40 MB or duration about 20 seconds")
            else  setValue(e?.target?.files[0])
            
          }}
          className="d-none"
          type="file"
          id={id}
          accept=".mp4"
        />
      </Card>
    </Label>
  );
};

export default VideoUploadInput;
